import React from 'react'
import './App.css'
import UniversalUploader from './components/UniversalUploader'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-[1600px] px-4 py-8">
        <UniversalUploader />
      </div>
    </div>
  )
}

export default App
